import * as THREE from 'three';
import CustomShaderMaterial from 'three-custom-shader-material/vanilla';
import fadeShader from '../shaders/fade.js';

export function createFadeShaderMaterial(options = {}) {
    const {
        fadeHeight = 5.5,
        brightness = 1.0,
        side = THREE.FrontSide
    } = options;

    return new CustomShaderMaterial({
        baseMaterial: THREE.MeshStandardMaterial,
        uniforms: {
            uDiffuseMap: { value: null },
            uHasDiffuseMap: { value: true },
            uColor: { value: null },
            uTerrainHeight: { value: null },
            uFadeHeight: { value: fadeHeight },
            uMeshPosition: { value: null },
            uBrightness: { value: brightness }
        },
        vertexShader: fadeShader.vert,
        fragmentShader: fadeShader.frag,
        side: side
    });
}
